module.exports = __webpack_public_path__ + "img/wl_sl3.0ab3bc35.jpg";